module.exports = __webpack_public_path__ + "static/img/6b675de.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dy/fir.png
// module id = 634
// module chunks = 2